/* GWP page interactions. Self-contained and independent of the base theme. */
(function () {
  "use strict";

  function initOfferBox(box) {
    var plans = Array.prototype.slice.call(box.querySelectorAll("[data-gwp-plan]"));
    var cta = box.querySelector("[data-gwp-cta]");
    var options = Array.prototype.slice.call(box.querySelectorAll("[data-gwp-option]"));
    var discount = box.getAttribute("data-gwp-discount") || "";

    function cartUrl(variantId) {
      var url = "/cart/" + variantId + ":1";
      if (discount) url += "?discount=" + encodeURIComponent(discount);
      return url;
    }

    function selectPlan(plan) {
      plans.forEach(function (candidate) {
        candidate.setAttribute("aria-checked", candidate === plan ? "true" : "false");
      });
      if (cta && plan.getAttribute("data-variant-id")) {
        cta.setAttribute("href", cartUrl(plan.getAttribute("data-variant-id")));
      }
    }

    plans.forEach(function (plan) {
      plan.addEventListener("click", function () {
        selectPlan(plan);
      });
    });

    options.forEach(function (option) {
      option.addEventListener("click", function () {
        options.forEach(function (candidate) {
          candidate.setAttribute("aria-pressed", candidate === option ? "true" : "false");
        });
        var target = option.getAttribute("data-gwp-option-target");
        if (!target) return;
        var plan = box.querySelector('[data-gwp-plan][data-variant-title="' + target + '"]');
        if (plan) selectPlan(plan);
      });
    });

    if (plans.length > 0) {
      selectPlan(box.querySelector('[data-gwp-plan][aria-checked="true"]') || plans[0]);
    }
  }

  function initStickyCta(sticky) {
    var threshold = parseInt(sticky.getAttribute("data-gwp-sticky-after") || "600", 10);
    var visible = false;

    function onScroll() {
      var shouldShow = window.scrollY > threshold;
      if (shouldShow === visible) return;
      visible = shouldShow;
      sticky.classList.toggle("is-visible", visible);
    }

    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
  }

  function initAnchorScroll(scope) {
    var links = scope.querySelectorAll('a[href^="#"]');
    Array.prototype.forEach.call(links, function (link) {
      link.addEventListener("click", function (event) {
        var id = link.getAttribute("href").slice(1);
        var target = id && document.getElementById(id);
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({ behavior: "smooth", block: "start" });
      });
    });
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll("[data-gwp-offer-box]"), initOfferBox);
    Array.prototype.forEach.call(document.querySelectorAll("[data-gwp-sticky]"), initStickyCta);
    Array.prototype.forEach.call(document.querySelectorAll(".gwp-scope"), initAnchorScroll);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
